<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Alert, Select, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { formatSnakeCaseToTitle } from 'src/helpers/utilities';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { format } from 'svelte-i18n';
	//Components
	import DeltaThresholdG2 from './DeltaThresholdG2.svelte';
	import RangeMapAnalogG2 from './RangeMapAnalogG2.svelte';
	import CustomPercentExpressionG2 from './CustomPercentExpressionG2.svelte';
	//Svelte hooks
	import { onMount } from 'svelte';
	//Stores

	export let device;

	let inputs = [];
	let settings = readDeviceSettings(device.id);
	let channel;
	const title = (item) => {
		switch (item.type) {
			case 'i18n_string_replace':
				//values contains props for translation
				let _obj = {};
				for (let k in item.values) {
					const v = item.values[k];
					_obj[k] = $format(v) || v;
				}
				return $format(item.title, {
					default: item.titleDefault,
					values: _obj,
				});

			case 'i18n_num_replace':
				return $format(item.title, {
					default: item.titleDefault,
					values: item.values,
				});

			default:
				return $format(item.title, { default: item.titleDefault });
		}
	};
	const analogSettings = [
		{
			title: 'delta_threshold',
			component: DeltaThresholdG2,
		},
		{
			title: '', //removing title, because component has it own title
			component: RangeMapAnalogG2,
		},
		{
			title: $format('sub_settings_title_input_counter_custom_expression_analog', {
				default: `Analog Input Custom Expression`,
			}),
			component: CustomPercentExpressionG2,
		},
	];

	const setChannel = (e) => {
		channel = e.detail.value;
	};

	const getSettings = () => {
		Object.keys(settings).forEach((setting, i) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				if (settings[`input:${Number(setting.split(':')[1])}`].type === 'analog') {
					inputs.push({
						title: +setting.split(':')[1],
						value: +setting.split(':')[1],
					});
				}
			}
		});
		inputs.sort((a, b) => a.title - b.title);
		channel = inputs?.[0]?.value;
	};

	onMount(() => {
		getSettings();
	});
</script>

{#if inputs?.length > 0 && typeof channel !== 'undefined'}
	<Text class="mt-s mb-s">{formatSnakeCaseToTitle($format('title_select_input'))}</Text>
	<Select
		class="mb-m"
		icon="fas fa-hashtag"
		options={inputs}
		value={{
			title: channel,
			value: channel,
		}}
		on:change={setChannel}
		id="select-w72sgnw"
		aria-label={$format('title_select_input', {
			default: 'Select input',
		})}
	/>
	{#each analogSettings as setting}
		{#if typeof channel !== 'undefined'}
			<Text styleType="h2" class="mb-s">{formatSnakeCaseToTitle(title(setting))}</Text>
			<svelte:component this={setting?.component} {device} {channel} />
		{/if}
	{/each}
{:else}
	<Alert
		class="mb-s"
		heading={$format('alert_heading_no_analog_inputs', {
			default: 'No analog inputs found',
		})}
		isHeadingBold
		message={$format('alert_message_first_set_analog_input', {
			default: 'If you want to use this feature, you first need to set at least one analog input.',
		})}
	/>
{/if}
